import { Cpu, Radio, Sparkles } from 'lucide-react';
import { cn } from '../../lib/utils';

const providerTone = {
  openai: 'border-violet-200/80 bg-violet-50 text-violet-900',
  xai: 'border-sky-200/80 bg-sky-50 text-sky-900',
};

export default function ModelBadge({ modelId, provider = 'openai', family = 'reasoning', className }) {
  const Icon = family === 'realtime' ? Radio : family === 'reasoning' ? Sparkles : Cpu;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium transition-[transform,background-color,border-color] duration-150 ease-out motion-reduce:transition-none',
        'hover:-translate-y-[1px]',
        providerTone[provider] || providerTone.openai,
        className,
      )}
    >
      <Icon className="h-3.5 w-3.5" />
      <span>{modelId}</span>
    </div>
  );
}
